import api from '../../api/index';
import router from '../../router';
import knowledge_check_test from './Knowledge_check_test';

export const COURSE_TYPES = {
  ACTIVE  : 'active',
  NEW     : 'new',
  COMPLETE: 'complete',
  EXPIRED : 'expired',
};

export default {
  namespaced: true,
  modules   : {knowledge_check_test},
  state     : {
    courses: {
      active  : [],
      new     : [],
      complete: [],
    },
    cards  : [],
    filters: [
      {
        text      : 'Текущие курсы',
        name      : COURSE_TYPES.ACTIVE,
        image     : 'course-lesson',
        label_text: 'Идёт обучение',
        selected  : true,
        color     : '#e2173d',
        card_image: 'study-book',
      },
      {
        text      : 'Новые курсы',
        name      : COURSE_TYPES.NEW,
        label_text: 'Новый',
        image     : 'course-go',
        selected  : false,
        color     : '#44b69e',
        card_image: 'study-book',
      },
      {
        text      : 'Завершенные курсы',
        name      : COURSE_TYPES.COMPLETE,
        label_text: 'Завершён',
        image     : 'course-complete',
        selected  : false,
        color     : '#9b9b9b',
        card_image: 'closed-book',
      },

    ],
    courses_number: {
      [COURSE_TYPES.ACTIVE]  : 0,
      [COURSE_TYPES.NEW]     : 0,
      [COURSE_TYPES.COMPLETE]: 0,
    },
    selected_course: {},
  },
  mutations: {
    SELECT_FILTER(state, index) {
      state.filters.forEach( (filter, i) => {
        filter.selected = (i === index);
      });
    },
    SET_COURSES_BY_FILTER(state, {filter, data}) {
      state.courses[filter] = data;
    },
    SET_COURSES_COUNT(state, {filter, count}) {
      state.courses_number[filter] = count;
    },
    SET_SELECTED_COURSE(state, course) {
      state.selected_course = course;
    },
  },
  getters: {
    course_lists         : ({courses}) => courses,
    cards                : ({cards}) => cards,
    courses_number       : ({courses_number}) => courses_number,
    filters              : ({filters}) => filters,
    selected_filter      : ({filters}) => filters.find((filter) => filter.selected),
    selected_filter_index: ({filters}) => filters.findIndex((filter) => filter.selected),
    get_selected_course  : ({selected_course}) => selected_course,
  },
  actions: {
    async get_course_by_id({commit}, id) {
      try {
        const courseResponse = await api.tests.get_assigned_test_by_id(id);
        commit('SET_SELECTED_COURSE', courseResponse.data);
      } catch (err) {
        if (err.message.indexOf('401')!==-1) {
          router.push({name: 'auth'});
          localStorage.clear();
        }
      }
    },
    async get_courses({getters, commit}) {
      const {filters} = getters;
      try {
        const allCourses = await Promise.all(filters.map((filter) => api.tests.get_tests(filter.name)));

        filters.forEach((filter, index) => {
          commit('SET_COURSES_BY_FILTER', {data: allCourses[index].data.data, filter: filter.name});
          commit('SET_COURSES_COUNT', {count: allCourses[index].data.pagination.total, filter: filter.name});
        });
      } catch (err) {
        if (err.message.indexOf('401')!==-1) {
          router.push({name: 'auth'});
          localStorage.clear();
        }
        filters.forEach((filter) => {
          commit('SET_COURSES_BY_FILTER', {data: [], filter: filter.name});
          commit('SET_COURSES_COUNT', {count: 0, filter: filter.name});
        });
      }
    },
  },
};

